import { Component } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class CreateComponent {
    private creating: boolean = true;
    public constructor(private http: Http, private router: Router) {
        let token = localStorage.getItem('amt_flyer_token');
        let headers = new Headers();
        headers.append('Authorization', token);

        this.http.put(environment.endpoint+'/create', {}, {headers: headers})
            .map(res => res.json(), err => err.json())
            .subscribe(
                res => {
                    if(res.status === 'OK')
                        this.router.navigate(['/view', res.results]);
                    else {
                        this.router.navigate(['/dashboard']);
                        alert(res.results);
                    }
                    this.creating = false;
                },
                err => {
                    alert(err);
                    this.router.navigate(['/dashboard']);
                    this.creating = false;
                }
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/create/create.component.ts